import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import TimestampFormatter from '../../components/admin/TimestampFormatter';

const TimestampProvider = props => (
  <DataTypeProvider formatterComponent={TimestampFormatter} {...props} />
);

export default TimestampProvider;
